import { useEffect, useRef } from 'react';

import { Workload } from '@cast/types';

import { NodeResourceOfferingFilter } from 'components/nodes';

import { StatusSelect } from './StatusSelect';

import { WorkloadsSelect } from './WorkloadsSelect';
import { resourceOfferingCriterion } from '../constants';
import { useCluster } from '@cast/shared-cluster-context-data-access';

import {
  ClearAllButton,
  Search,
  useSearchContext,
} from '@cast/shared-search-ui';

import { Stack } from '@cast/design-system';

type Props = {
  workloads?: Workload[];
};

export const NodeListFilters = ({ workloads }: Props) => {
  const { cluster } = useCluster();
  const searchState = useSearchContext();
  const initLoad = useRef(true);

  /** Lint disabling added since it's only required to reset filters when cluster id changes.
   * If we depend on searchState it will lead to infinite loop **/
  useEffect(() => {
    if (initLoad.current) {
      initLoad.current = false;
      return;
    }

    searchState?.resetInitial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster.id]);

  return (
    <Stack
      display="grid"
      gridTemplateColumns="auto 210px 210px 160px max-content"
      gap={8}
      mb={24}
    >
      <Search testId="node-list-search" />
      <WorkloadsSelect workloads={workloads} />
      <NodeResourceOfferingFilter criterion={resourceOfferingCriterion} />
      <StatusSelect />
      <ClearAllButton testId="clear-node-list-filters" />
    </Stack>
  );
};
